import enableDynamicLoginForm from "../adwerx-login/dynamic-login-form-action";

enableDynamicLoginForm();
